import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select, TextField } from "ui";
import { MenuItem } from "@mui/material";
import NetsModel from "./types/NetsModel";
import FormRef from "../types/FormRef";

type NetsFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: NetsModel) => void;
};

const NetsForm = forwardRef<FormRef, NetsFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    secret_key: {},
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Secret Key">
                                    <TextField
                                        fullWidth
                                        id="secret_key"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default NetsForm;
